export default __webpack_public_path__ + "static/media/kolowrotki.90c1589b.png";